export const PropertyNames = {
    name: "name",
    firstName: "firstName",
    lastName: "lastName",
    entityName: "EntityName",
    id: "Id"
}